export default {"src":"/_next/static/media/icon-photo-exposure-protection.43a17f56.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};